<div class="is-relative">
    <form [formGroup]="form" class="content-type-form" isavFieldIndex>
        <isav-field-index></isav-field-index>

        <isav-text-input
            label="1. Event title"
            formControlName="title"
            [mandatory]="true"
            tooltipKey="Event:title"
        ></isav-text-input>

        <isav-taxonomy-checkbox-list-input
            label="2. Topics"
            taxonomy="Topic"
            formControlName="topics"
            tooltipKey="Event:topics"
        ></isav-taxonomy-checkbox-list-input>

        <isav-many-input
            label="3. Event times"
            formControlName="startEndDates"
            tooltipKey="Event:startEndDates"
        >
            <isav-start-end-date-input
                *isavManyInputControl="let control; let position = position"
                [formControl]="control"
            ></isav-start-end-date-input>
        </isav-many-input>
        <isav-text-input
            label="4. Location"
            formControlName="location"
            tooltipKey="Event:location"
        ></isav-text-input>
        <isav-taxonomy-select-input
            label="5. Activity"
            formControlName="activity"
            taxonomy="Activity"
            tooltipKey="Event:activity"
        >
        </isav-taxonomy-select-input>
        <isav-text-input
            label="6. Contact name"
            formControlName="contactName"
            tooltipKey="Event:contactName"
        ></isav-text-input>
        <isav-text-input
            label="7. Contact phone"
            formControlName="contactPhone"
            tooltipKey="Event:contactPhone"
        ></isav-text-input>
        <isav-text-input
            label="8. Contact email"
            formControlName="contactEmail"
            tooltipKey="Event:contactEmail"
        ></isav-text-input>
        <isav-document-input
            label="9. Attachments"
            formControlName="attachments"
            tooltipKey="Event:attachments"
            [multiple]="true"
        ></isav-document-input>
        <isav-image-form
            label="10. Cover image"
            formControlName="coverImage"
            tooltipKey="Event:coverImage"
            property="coverImage"
            [contentIri]="value['@id']"
        ></isav-image-form>

        <isav-content-editor
            label="11. Description"
            formControlName="description"
            tooltipKey="Event:description"
            property="description"
            [iri]="value['@id']"
        ></isav-content-editor>

        <div class="is-flex is-space-between">
            <isav-go-to-view>Back to view</isav-go-to-view>
            <div class="buttons is-right">
                <ng-content></ng-content>
                <button type="button" isavBtn color="danger" class="ml-2" (click)="onDelete()">
                    Delete
                </button>
                <button
                    *ngIf="value.draft"
                    isavBtn
                    color="primary"
                    type="button"
                    [disabled]="isDisabled()"
                    (click)="onPublish()"
                >
                    Publish
                </button>
                <button
                    *ngIf="!value.draft"
                    isavBtn
                    color="danger"
                    type="button"
                    (click)="onUnpublish()"
                >
                    Unpublish
                </button>
                <button
                    type="button"
                    isavBtn
                    color="success"
                    [disabled]="!value.draft && isDisabled()"
                    (click)="onSave()"
                >
                    Save
                </button>
            </div>
        </div>
    </form>
</div>
